import moment from 'moment';

function dateToNum(date: any) {
    if (date === undefined || date === null) {
        return null;
    }

    const dateObj = new Date(moment(
        date
    ).format('MM/DD/YYYY'));

    const yearNumber = dateObj.getFullYear();
    const monthNumber = dateObj.getMonth();
    const dayNumber = dateObj.getDate();

    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 22/05/2023 => 20230522
    return result;
}

// DATE COMPARATOR FOR SORTING
export function dateComparator(date1: any, date2: any) {
    var date1Number = dateToNum(date1);
    var date2Number = dateToNum(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

export function dateComparatorWithStrDate(date1: any, date2: any) {
    date1 = moment.utc(
        date1,
        'MM/DD/YYYY h:mm:ss A Z');
    date2 = moment.utc(
        date2,
        'MM/DD/YYYY h:mm:ss A Z');
    var date1Number = dateToNum(date1);
    var date2Number = dateToNum(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

export function dateValueFormatterWOTime(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY') : '';
};

export function dateValueFormatter(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY h:mm:ss A Z') : '';
};

export function dateTimeValueFormatter(date: any) {
    if (!date) return '';
    const dateTime = moment.utc(date);
    return dateTime.isValid() ? dateTime.local().format('MM/DD/YYYY h:mm A') : '';
}

export function timeValueFormatter(date: any) {
    return date ? moment.utc(
        date
    ).local().format('h:mm:ss A') : '';
};


export function dateValueFormatterWithHHMM(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY H:mm') : '';
};

export function strToDate(strDate: any) {
    var localStartDate = moment
        .utc(strDate)
        .local()
        .format('MM/DD/YYYY H:mm');
    return new Date(localStartDate);
}

export function formattedTime(dateTime: Date) {
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    return formattedTime;
}

export const getLocalizationValues = (userProfileI: any, releaseSideSheetDataI: any) => {

    return {
        title: userProfileI?.locale === "en_CA" ?
            (releaseSideSheetDataI.titleLocale?.enCA && releaseSideSheetDataI.titleLocale?.enCA !== "" ? releaseSideSheetDataI.titleLocale?.enCA : releaseSideSheetDataI.title) :
            (userProfileI?.locale === "fr_CA" ? (releaseSideSheetDataI.titleLocale && releaseSideSheetDataI.titleLocale?.frCA !== "" ? releaseSideSheetDataI.titleLocale?.frCA : releaseSideSheetDataI.title) : releaseSideSheetDataI.title),
        subject: userProfileI?.locale === "en_CA" ?
            (releaseSideSheetDataI.subjectLocale && releaseSideSheetDataI.subjectLocale?.enCA !== "" ? releaseSideSheetDataI.subjectLocale?.enCA : releaseSideSheetDataI.subject) :
            (userProfileI?.locale === "fr_CA" ? (releaseSideSheetDataI.subjectLocale && releaseSideSheetDataI.subjectLocale?.frCA !== "" ? releaseSideSheetDataI.subjectLocale?.frCA : releaseSideSheetDataI.subject) : releaseSideSheetDataI.subject),
        body: userProfileI?.locale === "en_CA" ?
            (releaseSideSheetDataI.bodyLocale?.enCA !== '<br>' && releaseSideSheetDataI.bodyLocale?.enCA !== "" ? releaseSideSheetDataI.bodyLocale?.enCA : releaseSideSheetDataI.body) :
            (userProfileI?.locale === "fr_CA" ? (releaseSideSheetDataI.bodyLocale?.frCA !== '<br>' && releaseSideSheetDataI.bodyLocale?.frCA !== "" ? releaseSideSheetDataI.bodyLocale?.frCA : releaseSideSheetDataI.body) : releaseSideSheetDataI.body),
        externalUrl: userProfileI?.locale === "en_CA" ?
            (releaseSideSheetDataI.externalUrlLocale && releaseSideSheetDataI.externalUrlLocale?.enCA !== "" ? releaseSideSheetDataI.externalUrlLocale?.enCA : releaseSideSheetDataI.externalUrl) :
            (userProfileI?.locale === "fr_CA" ? (releaseSideSheetDataI.externalUrlLocale && releaseSideSheetDataI.externalUrlLocale?.frCA !== "" ? releaseSideSheetDataI.externalUrlLocale?.frCA : releaseSideSheetDataI.externalUrl) : releaseSideSheetDataI.externalUrl),    
    }
}

const resolveLocaleValue = (locale: string, localeObj?: any, fallback?: any) => {
    if (!localeObj || typeof localeObj !== "object")
        return fallback;

    if (locale === "en_CA") {
        return localeObj.enCA && localeObj.enCA !== "" ? localeObj.enCA : fallback;
    }

    if (locale === "fr_CA") {
        return localeObj.frCA && localeObj.frCA !== "" ? localeObj.frCA : fallback;
    }

    return localeObj.enUS && localeObj.enUS !== "" ? localeObj.enUS : fallback;
};

export const getLocalizedValues = (userProfile: any, data: any, fieldName: string) => {
    const locale = userProfile?.locale;
    const value = data[fieldName];
    if (value && typeof value === "object" && ("enUS" in value || "enCA" in value || "frCA" in value)) {
        return {
            [fieldName]: resolveLocaleValue(locale, value, value.enUS ?? "")
        };
    }
    return {
        [fieldName]: value
    };
};        

export const dateTimeComparatorAgGrid = (dateTimeInput: any, cellValue: any) => {
    if (!cellValue) {
        return -1;
    }

    const cellFormattedDate = new Date(cellValue);
    const applyFilter = dateTimeInput;

    const dateInput = new Date(cellFormattedDate.getFullYear(), cellFormattedDate.getMonth(), cellFormattedDate.getDate());

    if (dateInput < applyFilter) {
        return -1;
    }

    if (dateInput > applyFilter) {
        return 1;
    }

    return 0;

}

export const valueFormatterAgGrid = (params: any) => {
    if (!params.value) {
        return;
    }

    const date = new Date(params.value);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}
